// extracted by mini-css-extract-plugin
export default {"unauthorized":"_1mA4j51FaoCv-sTern_d1F"};